import { render, staticRenderFns } from "./loss.vue?vue&type=template&id=6fa7a194&scoped=true&"
import script from "./loss.vue?vue&type=script&lang=js&"
export * from "./loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7a194",
  null
  
)

export default component.exports